import ActionsTable from 'components/cta/ActionsTable'
import React from 'react'
import PageContent from 'components/common/PageContent'

export default function Posts(props) {
    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Posts"}
    ];

    return (
        <PageContent pathElements={pathElements} >
            <ActionsTable/>
        </PageContent>
    );
}